(function() {
	Vue.component('nominow-table-detail-result', {
		template: `
        <div>
        <div v-if="data.items == null">
        {{data.message}}
        </div>
        <div v-if="data.items != null">
        <nominow-tableresults v-bind:items.sync="data.items" :pagination="{}"></nominow-tableresults>
        </div>
        </div>
        `,
		props: {
			data: {
				type: Object,
				required: true,
				default: () => ({
					items: Array,
					message: String
				})
			}
		}
	});
})();
